// src/hooks/useChat.ts
import { useMemo } from 'react';
import { useCreateChatClient } from 'stream-chat-react';
import { ChatStore } from '../api/ChatStore';
import { useAppCookies } from '@app/providers/AppCookieProvider';

const API_KEY = import.meta.env.VITE_APP_STREAM_API_KEY!;

export function useChat() {
  const cookies = useAppCookies();

  // Always define the token provider — do not gate with an early return
  const tokenOrProvider = useMemo(() => {
    return async () => {
      const userId = Number(cookies.profile?.id);
      const store = new ChatStore();
      const { result: token } = await store.CreateChatToken(userId);
      return token;
    };
  }, [cookies.profile?.id]);

  const streamOptions = {
    timeout: 10000,
  };

  // Always call the hook — but pass null if profile is missing
  const client = cookies.profile.available
    ? useCreateChatClient({
        apiKey: API_KEY,
        tokenOrProvider,
        userData: {
          id: String(cookies.profile.id),
          name: `${cookies.profile.firstName} ${cookies.profile.lastName}`,
          image: cookies.profile.picture,
        },
        options: streamOptions,
      })
    : null;

  return { client };
}
